import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#151b22',
      light: '#232c36',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#3b82f6',
      dark: '#1d4ed8',
      contrastText: '#151b22',
    },
    text: {
      primary: '#ffffff',
      secondary: '#9aa7b3',
    },
    background: {
      default: '#151b22',
      paper: '#1c232b',
    },
  },
  typography: {
    fontFamily: '"GeogrotesqueCyr", "Helvetica Neue", serif',
  },
});

export default theme;
